import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthGuardOptions } from '../types/AuthGuardTypes';
import { useAuthStore } from '../stores/useAuthStore';

export const useAuthGuard = (options: AuthGuardOptions = {}) => {
  const navigate = useNavigate();
  const {
    redirectTo = '/login',
    message = 'Please log in to access this page.',
    onAuthenticated,
  } = options;

  const { isAuthenticated, initializeAuth } = useAuthStore();

  const onAuthenticatedRef = useRef<(() => void) | undefined>(undefined);
  onAuthenticatedRef.current = onAuthenticated;

  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(redirectTo, { replace: true });
      return;
    }

    onAuthenticatedRef.current?.();
  }, [isAuthenticated, navigate, redirectTo, message]);

  return { isAuthenticated };
};

export const useSecondaryAuthGuard = () => {
  const navigate = useNavigate();
  const isVerified = sessionStorage.getItem('log_in') === 'is_logged_in';

  useEffect(() => {
    if (!isVerified) {
      alert('Please verify your password to access this page.');
      navigate('/mypage', { replace: true });
    }
  }, [isVerified, navigate]);

  return { isVerified };
};
